import React from 'react';
import { Plus } from 'lucide-react';
import { FaqItem } from '../../data/masterclass';

interface FaqAccordionProps {
  items: FaqItem[];
}

const FaqAccordion: React.FC<FaqAccordionProps> = ({ items }) => {
  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <details
          key={item.question}
          className="group rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-md"
          open={index === 0}
        >
          <summary className="flex cursor-pointer list-none items-center justify-between font-display font-semibold text-white">
            {item.question}
            <Plus className="h-5 w-5 shrink-0 text-white/50 transition-transform duration-300 group-open:rotate-45" />
          </summary>
          <p className="mt-3 text-sm font-light leading-relaxed text-white/65">{item.answer}</p>
        </details>
      ))}
    </div>
  );
};

export default FaqAccordion;
